import { FC, useEffect, useState } from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { Input } from '@abtasty/design-system';
import { useTranslation } from 'react-i18next';
import { Navigation } from '@src/application/modules/tag/shared/constants';
import { useDebounce } from 'react-use';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';

import styles from './Search.module.scss';
import { useIsMobile } from '@src/application/hooks/useIsMobile';

type SearchProps = {
  setCampaignSearch: (value: string) => void;
  setEventsSearch: (value: string) => void;
  setTransactionSearch: (value: string) => void;
  onChange?: (value: string) => void;
};
export const Search: FC<SearchProps> = ({ setCampaignSearch, setEventsSearch, setTransactionSearch, onChange }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const segmentTrack = useSegmentTrack();
  const [inputValue, setInputValue] = useState('');

  const setSearch = (value: string) => {
    onChange && onChange(value);
    if (pathname === Navigation.Campaigns) setCampaignSearch(value);
    else if (pathname === Navigation.Transactions) setTransactionSearch(value);
    else if (pathname === Navigation.Events) setEventsSearch(value);
  };

  useEffect(() => {
    setInputValue('');
    setSearch('');
  }, [pathname]);

  useDebounce(() => setSearch(inputValue), 300, [inputValue]);

  const isMobile = useIsMobile();

  return (
    <Input
      type="search"
      variant={isMobile ? 'filled' : undefined}
      onFocus={() => segmentTrack('Qa - Click search')}
      size={isMobile ? 'default' : 'small'}
      className={classnames(styles.searchContainer, { [styles.desktop]: !isMobile })}
      innerWrapperClassName={styles.search}
      placeholder={
        pathname === Navigation.Campaigns ? t('Search for campaign, id, name, type') : t('Search event name, id, type')
      }
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      clearSearch={() => setInputValue('')}
    />
  );
};
